import { useI18n } from "../i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer style={{ background: "var(--midnight)", color: "var(--bone)" }} data-testid="site-footer">
      <div className="container-x py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="serif-display" style={{ fontSize: 44 }}>GIANO</div>
            <p className="mt-4 text-sm" style={{ opacity: 0.7, maxWidth: 360 }}>
              {t("footer.tagline")}
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="overline" style={{ opacity: 0.5 }}>Sede</div>
            <p className="mt-3 text-sm" style={{ opacity: 0.85 }}>
              Via Broletto 16<br />20121 Milano · IT<br />+39 02 4700 3200<br />info@giano.com
            </p>
          </div>
          <div className="md:col-span-4">
            <div className="overline" style={{ opacity: 0.5 }}>Governance</div>
            <ul className="mt-3 space-y-2 text-sm" style={{ opacity: 0.85 }}>
              <li><a href="/chi-siamo">Chi siamo</a></li>
              <li><a href="/metodo">Il metodo</a></li>
              <li><a href="#portfolio">Portafoglio</a></li>
              <li><a href="/case-studies">Storie</a></li>
              <li><a href="/admin/login" data-testid="footer-admin-link">{t("nav.admin")}</a></li>
            </ul>
            <div className="overline mt-6" style={{ opacity: 0.5 }}>Cerchi in una regione?</div>
            <ul className="mt-3 space-y-2 text-sm font-mono" style={{ opacity: 0.75 }}>
              <li><a href="/vendere-azienda/lombardia">Vendere in Lombardia</a></li>
              <li><a href="/vendere-azienda/veneto">Vendere in Veneto</a></li>
              <li><a href="/vendere-azienda/emilia-romagna">Vendere in Emilia-Romagna</a></li>
              <li><a href="/vendere-azienda/piemonte">Vendere in Piemonte</a></li>
              <li><a href="/vendere-azienda/toscana">Vendere in Toscana</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 flex flex-col md:flex-row md:items-center justify-between gap-4"
             style={{ borderTop: "1px solid rgba(247,245,240,0.15)" }}>
          <div className="font-mono text-xs" style={{ opacity: 0.6 }}>
            © {new Date().getFullYear()} GIANO Holding S.p.A. — {t("footer.rights")}
          </div>
          <div className="flex gap-6 font-mono text-xs" style={{ opacity: 0.6 }}>
            <a href="/privacy">{t("footer.privacy")}</a>
            <a href="/privacy">{t("footer.legal")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
